import React from 'react';
import PropTypes from 'prop-types';

import { withConfig } from 'Context/ConfigContext';
import NoMatchPaaS from 'Components/PaaS/NoMatch/NoMatchPaaS.view';

const NoMatchPAASRoute = ({ history, appConfig }) => {
  const { landingRoute = '/my-courses' } = appConfig;
  return (
    <NoMatchPaaS
      onButtonClick={() => {
        history.push(landingRoute);
      }}
    />
  );
};

NoMatchPAASRoute.propTypes = {
  appConfig: PropTypes.shape({
    landingRoute: PropTypes.string,
  }),
};

export default withConfig(NoMatchPAASRoute);
